module.exports = __webpack_public_path__ + "img/_fb368da7-465d-40c0-a902-38d808a3171c.21ce4e1f.jpeg";